import { isPlayerInRound } from "vue-chess-shared/tournament/utils/playerUtils";

export default {
  data() {
    return {};
  },

  computed: {
    activePlayers() {
      return this.players.filter((p) => !p.deletedAt);
    },

    sortedPlayers() {
      const roundNumber = Math.min(
        this.tournament.currentRound,
        this.tournament.totalRounds
      );

      return this.activePlayers
        .map((p) => ({
          ...p,
          isParticipating: isPlayerInRound(p, roundNumber),
          seed:
            p.user && p.user.stats && p.user.stats.rating
              ? p.user.stats.rating
              : 0,
          games: this.games.filter(
            (g) =>
              g.whiteUsername === p.username || g.blackUsername === p.username
          ),
        }))
        .sort((a, b) => b.score - a.score || b.seed - a.seed);
    },

    sortedRounds() {
      if (!this.rounds) return [];
      return [...this.rounds].sort((a, b) => a.roundNumber - b.roundNumber);
    },
  },
};
